import { createStyles, List, ListItem, ListItemText, makeStyles, Theme, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { ChangeEvent } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '../../../../../../components/accordion/accordion.styled';
import { MessagingNodeData } from '../flow';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      width: '100%',
      paddingTop: 0,
      paddingBottom: 0,
    },
    listStriped: {
      '& li:nth-child(odd)': {
        backgroundColor: '#f2f2f2'
      }
    },
    itemKey: { width: '45%' },
    itemValue: {
      width: '55%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      paddingLeft: theme.spacing(1)
    }
  })
);

export function OptionsPanel(props: {
  data: MessagingNodeData,
  expanded: string | boolean,
  onAccordionStateChange: (panel: any) => (_event: ChangeEvent<{}>, isExpanded: boolean) => void
}) {

  const { data, expanded, onAccordionStateChange } = props;
  const { spec } = data;

  const classes = useStyles();

  return (<Accordion expanded={expanded === 'options'} onChange={onAccordionStateChange('options')}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>Options</AccordionSummary>
    <AccordionDetails>
      {Object.entries(spec.arguments).length > 0 ? (<>
        <List dense className={`${classes.list} ${classes.listStriped}`} >
          {[...Object.entries(spec.arguments)]
            .map((opt: any, index) => (
              <ListItem key={index}>
                <ListItemText className={classes.itemKey} primary={opt[0]} title={opt[0]} />
                <ListItemText className={classes.itemValue} secondary={`${opt[1]}`} title={`${opt[1]}`} />
              </ListItem>
            ))}
        </List>
      </>) : (
        <Typography variant='caption' component='p'>No options to show.</Typography>
      )}
    </AccordionDetails>
  </Accordion>);
};
